import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetProcessorsQuery,
  GetProcessorsQueryVariables,
} from '#graphql/generated';

export const GET_PROCESSORS: TypedDocumentNode<
  GetProcessorsQuery,
  GetProcessorsQueryVariables
> = gql`
  query GetProcessors {
    processors {
      processors {
        id
        fileId
        createdAt
        updatedAt
      }
    }
  }
`;
